import { BlogSection } from '@/types/blog';

export const emotionsFinanceSection: BlogSection = {
  id: 'emotionen-finanzentscheidungen',
  title: 'Wie Emotionen unsere finanziellen Entscheidungen steuern',
  content: `
    <p>
      Menschen treffen Entscheidungen nicht rein rational, sondern stark emotional gesteuert – besonders bei Finanzthemen:
    </p>
    
    <ul>
      <li><strong>Angst und Gier</strong> sind die mächtigsten Treiber an Finanzmärkten und führen oft zu übereilten Käufen oder Verkäufen</li>
      <li><strong>FOMO (Fear of Missing Out)</strong> – die Angst, eine Gelegenheit zu verpassen – treibt Menschen in Investments, die sie nicht verstehen</li>
      <li><strong>Bestätigungsverzerrung</strong> lässt uns Informationen bevorzugen, die unsere bestehenden Überzeugungen bestätigen</li>
      <li><strong>Soziale Bestätigung</strong> verleitet uns, Entscheidungen zu treffen, weil "alle anderen" es auch tun</li>
    </ul>
    
    <p>
      Soziale Medien verstärken diese emotionalen Reaktionen gezielt. Algorithmen erkennen, welche Inhalte starke Emotionen auslösen und zeigen uns mehr davon, um unsere Aufmerksamkeit zu halten. So entstehen Echokammern, in denen extreme Standpunkte dominieren.
    </p>
  `
};
